import { render, staticRenderFns } from "./news0.vue?vue&type=template&id=43313adc&scoped=true&"
import script from "./news0.vue?vue&type=script&lang=js&"
export * from "./news0.vue?vue&type=script&lang=js&"
import style0 from "./news0.vue?vue&type=style&index=0&id=43313adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43313adc",
  null
  
)

export default component.exports